export default "__VITE_ASSET__e3abf3f7__"